// utils
import { formatProcedureCallback } from './formatProcedureCallback';
import { formatEquipmentCallback } from './formatEquipmentCallback';
import { formatFurnitureCallback } from './formatFurnitureCallback';
import { formatProfessionCallback } from './formatProfessionCallback';

function initiateIndicationStep(indications) {
  const professions = indications.professions.map(formatProfessionCallback);
  const furnitures = indications.furnitures.map(formatFurnitureCallback);
  const procedures = indications.procedures.map(formatProcedureCallback);
  const equipments = indications.equipments.map(formatEquipmentCallback);

  const indicationstep = {
    professions,
    furnitures,
    procedures,
    equipments
  };

  return indicationstep;
}

export { initiateIndicationStep };
